import { useMemo } from "react";
import { TypeOfTemplate } from "../../../../clients/graphqlTypes.js";
import { useTranslate } from "@tolgee/react";

const TYPES: TypeOfTemplate[] = ["structure", "configuration"];

export function useTypeOfTemplates() {
  const { t } = useTranslate("Templates");

  const typeOfTemplatesLabels: Record<TypeOfTemplate, string> = useMemo(
    () => ({
      structure: t("Structure"),
      configuration: t("Configuration"),
    }),
    [t]
  );

  const typeOfTemplatesOptions = useMemo(
    () =>
      TYPES.map(type => ({
        value: type,
        label: typeOfTemplatesLabels[type],
      })),
    [typeOfTemplatesLabels]
  );

  return { typeOfTemplatesLabels, typeOfTemplatesOptions };
}
